/* ==========================================================================
   Autoklar — theme.js (vanilla, no dependencies)
   Cart drawer · variant picker · gallery · bundles · sticky ATC · accordion
   ========================================================================== */
(function () {
  'use strict';

  var A = window.Autoklar || {};
  var S = A.strings || {};
  var R = A.routes || {};

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || A.moneyFormat || '{{amount_with_comma_separator}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    var value = '';
    switch (m ? m[1] : 'amount_with_comma_separator') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    // strip any HTML from the shop money format (e.g. <span class=money>)
    var out = format.replace(placeholder, value);
    var tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent || tmp.innerText || out;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- Drawers (menu + cart) ---------- */
  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  // Close mobile menu when resizing to desktop
  window.addEventListener('resize', debounce(function () {
    if (window.innerWidth >= 990) closeDrawer(document.getElementById('MenuDrawer'));
  }, 150));

  /* ---------- Header search ---------- */
  var searchPanel = $('[data-search-panel]');
  $$('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchPanel) return;
      var willOpen = searchPanel.hasAttribute('hidden');
      if (willOpen) searchPanel.removeAttribute('hidden'); else searchPanel.setAttribute('hidden', '');
      $$('[data-search-toggle][aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); });
      if (willOpen) { var input = $('input[type="search"]', searchPanel); if (input) input.focus(); }
    });
  });

  /* ---------- Cart ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
  }

  function renderCartDrawer(html) {
    if (!cartDrawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]', cartDrawer);
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCartCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    }
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCartDrawer(data['cart-drawer']); });
  }

  // Cart icon opens the drawer (if present) instead of navigating
  $$('[data-cart-open]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!cartDrawer || A.isCartPage) return;
      e.preventDefault();
      openDrawer(cartDrawer);
    });
  });

  function setButtonsState(buttons, state) {
    buttons.forEach(function (btn) {
      var txt = $('[data-btn-text]', btn) || btn;
      if (state === 'loading') {
        btn.dataset.originalText = txt.textContent;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        txt.textContent = S.adding || '…';
      } else if (state === 'added') {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        txt.textContent = S.added || '✓';
        setTimeout(function () { txt.textContent = btn.dataset.originalText || S.addToCart; }, 1600);
      } else {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        txt.textContent = btn.dataset.originalText || S.addToCart;
      }
    });
  }

  function showFormError(form, message) {
    var box = $('[data-form-error]', form);
    if (!box) { if (message) window.alert(message); return; }
    if (message) { box.textContent = message; box.removeAttribute('hidden'); }
    else { box.textContent = ''; box.setAttribute('hidden', ''); }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    // Without a drawer (disabled in settings or on /cart) fall back to native submit → /cart
    if (!cartDrawer || A.isCartPage || !window.fetch || !window.FormData) return;
    e.preventDefault();

    var buttons = $$('[data-add-to-cart]', form);
    if (form.id) buttons = buttons.concat($$('[form="' + form.id + '"][data-add-to-cart]'));
    if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return;

    showFormError(form, '');
    setButtonsState(buttons, 'loading');

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);

    fetch(R.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = (res.data && (res.data.description || res.data.message)) || S.error;
          throw new Error(msg);
        }
        setButtonsState(buttons, 'added');
        if (res.data.sections && res.data.sections['cart-drawer']) {
          renderCartDrawer(res.data.sections['cart-drawer']);
        } else {
          return refreshCartDrawer();
        }
      })
      .then(function () { openDrawer(cartDrawer); })
      .catch(function (err) {
        setButtonsState(buttons, 'reset');
        showFormError(form, err && err.message ? err.message : S.error);
      });
  });

  // Drawer quantity +/- and remove
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn || !cartDrawer) return;
    e.preventDefault();
    var qty = Math.max(0, parseInt(btn.getAttribute('data-qty'), 10) || 0);
    cartDrawer.classList.add('is-loading');
    fetch(R.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-line-change'), quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.description) window.alert(data.description);
        if (data.sections && data.sections['cart-drawer']) renderCartDrawer(data.sections['cart-drawer']);
        else return refreshCartDrawer();
        if (typeof data.item_count === 'number') updateCartCount(data.item_count);
      })
      .catch(function () { window.alert(S.error); })
      .then(function () { cartDrawer.classList.remove('is-loading'); });
  });

  // Cart page: auto-submit quantity changes
  $$('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { if (input.form) input.form.submit(); });
  });

  /* ---------- Quantity stepper (product page) ---------- */
  $$('[data-qty-stepper]').forEach(function (wrap) {
    var input = $('input', wrap);
    function set(v) {
      var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 99;
      input.value = Math.min(max, Math.max(min, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    $('[data-qty-minus]', wrap).addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    $('[data-qty-plus]', wrap).addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
  });

  /* ---------- Accordion: single-open groups ---------- */
  $$('[data-accordion][data-single]').forEach(function (acc) {
    var items = $$('details', acc);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb-index]', root);
    var counter = $('[data-gallery-current]', root);
    var current = 0;

    function setActive(i) {
      current = i;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
        if (idx !== i) $$('video', s).forEach(function (v) { try { v.pause(); } catch (err) {} });
      });
      thumbs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        if (on && t.parentElement && t.parentElement.parentElement) {
          var list = t.parentElement.parentElement;
          var left = t.parentElement.offsetLeft - (list.clientWidth - t.parentElement.clientWidth) / 2;
          list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      });
      if (counter) counter.textContent = i + 1;
    }

    function goTo(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      var prev = track.style.scrollBehavior;
      if (instant) track.style.scrollBehavior = 'auto';
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      if (instant) track.style.scrollBehavior = prev;
      setActive(i);
    }

    track.addEventListener('scroll', debounce(function () {
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i !== current && i >= 0 && i < slides.length) setActive(i);
    }, 60), { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb-index'), 10) || 0); });
    });
    var prevBtn = $('[data-gallery-prev]', root), nextBtn = $('[data-gallery-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Keyboard arrows when the gallery has focus
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    // Initial: jump to the slide marked active (selected variant image)
    var startIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (startIdx > 0) { requestAnimationFrame(function () { goTo(startIdx, true); }); } else { setActive(0); }

    // Keep position on resize
    window.addEventListener('resize', debounce(function () { goTo(current, true); }, 150));

    return {
      goToMedia: function (mediaId) {
        if (!mediaId) return;
        var idx = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(mediaId); });
        if (idx > -1) goTo(idx);
      }
    };
  }

  /* ---------- Product section ---------- */
  function initProductSection(section) {
    var jsonEl = $('[data-variant-json]', section);
    var variants = [];
    try { variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]'); } catch (err) { variants = []; }

    var gallery = initGallery(section);
    var formId = section.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var qtyInput = form ? $('[data-quantity-input]', form) : null;
    var picker = $('[data-variant-picker]', section);
    var bundles = $('[data-bundles]', section);
    var currentVariant = null;

    if (idInput) {
      var startId = parseInt(idInput.value, 10);
      currentVariant = variants.find(function (v) { return v.id === startId; }) || variants[0] || null;
    }

    function atcButtons() {
      var list = form ? $$('[data-add-to-cart]', form) : [];
      return list.concat($$('[form="' + formId + '"][data-add-to-cart]'));
    }

    // Same math as Shopify: percentage per unit, unit discount rounded down
    function bundleTotal(price, q, d) { return q * (price - Math.floor(price * d / 100)); }

    function updateBundles() {
      if (!bundles || !currentVariant) return;
      $$('[data-bundle-qty]', bundles).forEach(function (input) {
        var q = parseInt(input.getAttribute('data-bundle-qty'), 10) || 1;
        var d = parseFloat(input.getAttribute('data-bundle-discount')) || 0;
        var regular = currentVariant.price * q;
        var body = input.nextElementSibling;
        var totalEl = body ? $('[data-bundle-total]', body) : null;
        var regEl = body ? $('[data-bundle-regular]', body) : null;
        if (totalEl) totalEl.textContent = formatMoney(bundleTotal(currentVariant.price, q, d));
        if (regEl && regEl.lastChild && regEl.lastChild.nodeType === 3) regEl.lastChild.nodeValue = formatMoney(regular);
      });
      updateStickyPrice();
    }

    function selectedQty() {
      if (bundles) {
        var checked = $('[data-bundle-qty]:checked', bundles);
        return checked ? parseInt(checked.getAttribute('data-bundle-qty'), 10) || 1 : 1;
      }
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    function updateStickyPrice() {
      var el = $('[data-sticky-price]', section);
      if (!el || !currentVariant) return;
      var q = selectedQty();
      var d = 0;
      if (bundles) {
        var checked = $('[data-bundle-qty]:checked', bundles);
        d = checked ? parseFloat(checked.getAttribute('data-bundle-discount')) || 0 : 0;
      }
      var total = bundleTotal(currentVariant.price, q, d);
      el.textContent = (q > 1 ? q + '× ' : '') + formatMoney(total);
    }

    if (bundles) {
      bundles.addEventListener('change', function (e) {
        var input = e.target.closest('[data-bundle-qty]');
        if (!input || !qtyInput) return;
        qtyInput.value = input.getAttribute('data-bundle-qty');
        updateStickyPrice();
      });
    }
    if (qtyInput && !bundles) qtyInput.addEventListener('change', updateStickyPrice);

    function selectedOptions() {
      if (!picker) return [];
      var groups = $$('.variant-group', picker);
      return groups.map(function (g) {
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
    }

    function updateAvailability(selected) {
      if (!picker) return;
      $$('input[data-option-index]', picker).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var possible = variants.some(function (v) {
          if (!v.available) return false;
          if (v.options[idx] !== input.value) return false;
          for (var i = 0; i < selected.length; i++) {
            if (i === idx) continue;
            if (selected[i] !== null && v.options[i] !== selected[i]) return false;
          }
          return true;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !possible);
      });
    }

    function renderVariant(variant) {
      var buttons = atcButtons();
      var priceWrap = $('.pdp__price-wrap', section);
      var priceEl = priceWrap ? $('[data-price]', priceWrap) : null;
      var compareEl = priceWrap ? $('[data-compare]', priceWrap) : null;
      var unitEl = priceWrap ? $('[data-unit-price]', priceWrap) : null;
      var availText = $('[data-availability-text]', section);
      var dot = $('[data-availability] .dot', section);

      if (!variant) {
        buttons.forEach(function (b) {
          b.disabled = true;
          var t = $('[data-btn-text]', b) || b; t.textContent = S.unavailable;
          b.dataset.originalText = S.unavailable;
        });
        if (availText) availText.textContent = S.unavailable;
        if (dot) dot.classList.add('dot--off');
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (priceWrap) {
        var priceBox = $('.price', priceWrap);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (priceBox) priceBox.classList.toggle('price--sale', !!onSale);
        if (compareEl) {
          if (onSale) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.removeAttribute('hidden'); }
          else { compareEl.textContent = ''; compareEl.setAttribute('hidden', ''); }
        }
      }
      if (unitEl) {
        if (variant.unit_price) { unitEl.textContent = '(' + formatMoney(variant.unit_price) + ' / ' + (variant.unit_ref || '') + ')'; unitEl.removeAttribute('hidden'); }
        else unitEl.setAttribute('hidden', '');
      }

      var label = variant.available ? S.addToCart : S.soldOut;
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        var t = $('[data-btn-text]', b) || b;
        t.textContent = label;
        b.dataset.originalText = label;
      });

      if (availText) {
        if (!availText.dataset.availableText) availText.dataset.availableText = availText.textContent;
        availText.textContent = variant.available ? availText.dataset.availableText : S.unavailable;
      }
      if (dot) dot.classList.toggle('dot--off', !variant.available);

      if (gallery && variant.media_id) gallery.goToMedia(variant.media_id);

      // URL ?variant=
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}

      updateBundles();
    }

    if (picker) {
      // Remember initial availability text so it can be restored
      var at = $('[data-availability-text]', section);
      if (at && currentVariant && currentVariant.available) at.dataset.availableText = at.textContent;

      picker.addEventListener('change', function (e) {
        var input = e.target.closest('input[data-option-index]');
        if (!input) return;
        var idx = input.getAttribute('data-option-index');
        var lbl = $('[data-selected-label="' + idx + '"]', picker);
        if (lbl) lbl.textContent = input.value;

        var selected = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] === o; });
        });

        // If the exact combination does not exist, pick the closest available one for the changed option
        if (!match) {
          var changedIdx = parseInt(idx, 10);
          match = variants.find(function (v) { return v.available && v.options[changedIdx] === input.value; }) ||
                  variants.find(function (v) { return v.options[changedIdx] === input.value; });
          if (match) {
            match.options.forEach(function (val, i) {
              var radio = $$('input[data-option-index="' + i + '"]', picker).find(function (r) { return r.value === val; });
              if (radio) radio.checked = true;
              var l = $('[data-selected-label="' + i + '"]', picker);
              if (l) l.textContent = val;
            });
            selected = selectedOptions();
          }
        }
        currentVariant = match || null;
        renderVariant(currentVariant);
        updateAvailability(selected);
      });
      updateAvailability(selectedOptions());
    }

    updateBundles();
    updateStickyPrice();

    /* Sticky ATC: show after the main button scrolled out of view (above viewport) */
    var sticky = $('[data-sticky-atc]', section);
    var mainBtn = $('[data-main-atc]', section);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var sb = $('button', sticky);
          if (sb) sb.tabIndex = show ? 0 : -1;
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
  }

  $$('[data-product-section]').forEach(initProductSection);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (section) {
    var url = section.getAttribute('data-url');
    var grid = $('[data-recs-grid]', section);
    function hideIfEmpty() { if (grid && !grid.querySelector('li')) section.classList.add('is-empty'); }
    if (!url || !window.fetch) { hideIfEmpty(); return; }
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs-grid]');
        if (fresh && fresh.getAttribute('data-recs-source') === 'recommendations' && fresh.querySelector('li')) {
          grid.replaceWith(fresh);
          grid = fresh;
        }
        hideIfEmpty();
      })
      .catch(hideIfEmpty);
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
  });

  /* ---------- Address forms: preselect country ---------- */
  $$('select[data-default]').forEach(function (sel) {
    var def = sel.getAttribute('data-default');
    if (!def) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === def || sel.options[i].text === def) { sel.selectedIndex = i; break; }
    }
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProductSection);
  });
})();
